<template>
    <div>

        <rkm-row v-if="items && items.length > 0">
            <rkm-col>

                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    color="info"
                    class="mb-2"
                    @click="openModalMultipleSms()"
                >
                    <rkm-icon icon="sms" class="mr-1" /> Configurar SMS para selecionado(s)
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-table
            :items="items"
            :fields="fields.tables.tipo"
            sort-by="nomeFantasia"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-checkbox
                    v-model="item.checked"
                    @change="handleBlur"
                    :disabled="item.tipo == 'Prestador'"
                />
            </template>

            <template v-slot:cell(enviaSms)="{item}">
                <rkm-form-checkbox v-model="item.enviaSms" @change="handleEnviaSms(item)" :disabled="item.tipo == 'Prestador'" />
            </template>

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    :disabled="item.tipo == 'Prestador'"
                    @click="$refs.ModalSms.open(item)"
                    color="info"
                    small
                    title="Configuração de SMS"
                >
                    <rkm-icon icon="sms" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalSms
            :data="data"
            ref="ModalSms"
        />

        <ModalMultipleSms
            :data="data"
            :items="items.filter(item => item.checked)"
            ref="ModalMultipleSms"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalSms from './components/sms/Modal'
import ModalMultipleSms from './components/multiple-sms/Modal'

export default {
    components: { Modal, ModalSms, ModalMultipleSms },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'checkbox', label: '#', class: 'col-min text-center' },
                        { key: 'nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'tipo', label: 'Tipo', sortable: true },
                        { key: 'enviaSms', label: 'Envia SMS' },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        }
    },
    data: () => ({
        items: [],
        selecionados: false,
    }),
    methods: {
        handleDestroy(item) {

            const hasUnidade = this.data.model.cotas
                .find(cc => cc.unidadeId === item.unidadeId && cc.infraestruturaId === item.infraestruturaId)

            if (hasUnidade) {

                this.showValidationNotification(`Não é possível excluir a unidade <strong>${ item.nomeFantasia }</strong> e o
                local de atendimento <strong>${ item.infraestruturaNome }</strong>, pois já possui cota(s).`)

                return false
            }

            const objIndex = this.data.model.unidades.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.unidades.splice(objIndex, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
        selecionarTodos(){

            if(this.selecionados == true){

                this.selecionados = false
            } else {

                this.selecionados = true
            }

            this.items.forEach(element => {

                if(this.selecionados == true){

                    if (element.tipo != 'Prestador') {

                        element.checked = true
                    }
                } else {

                    element.checked = false
                }
            })
        },
        handleBlur(){

            let checked = false

            this.items.map(element => {

                if (element.checked == true) {

                    checked = true
                }
            })

            if (checked) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        handleEnviaSms(item){

            const objId = this.data.model.unidades.findIndex((obj => obj.id == item.id));

            if (objId >= 0) {
                this.data.model.unidades[objId].enviaSms = item.enviaSms
            }
        },
        openModalMultipleSms() {

            const hasSms = this.items.filter(item => item.checked && item.sms?.diaAntecedencia)

            if (hasSms.length > 0) {
                const nomes = hasSms.map(item => `<strong>${item.nomeFantasia} - ${item.infraestruturaNome}</strong>`).join(', ')

                this.showConfirmation(
                    `As seguintes unidades já possuem configurações de SMS parametrizadas e, ao continuar, essas
                        configurações serão substituídas: ${nomes}. Deseja continuar?`,
                    async () => this.$refs.ModalMultipleSms.open()
                )
            } else {
                this.$refs.ModalMultipleSms.open()
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.unidades' (unidades) {
            this.items = unidades.map(unidade => {

                let tipo = ''

                if (unidade.executante && unidade.prestador) {
                    tipo = 'Executante / Prestador'
                }
                else if (unidade.executante) {
                    tipo = 'Executante'
                }
                else if (unidade.prestador) {
                    tipo = 'Prestador'
                }

                return {
                    id: unidade.id,
                    nomeFantasia: unidade.nomeFantasia,
                    infraestruturaNome: unidade.infraestruturaNome,
                    infraestruturaId: unidade.infraestruturaId,
                    unidadeId: unidade.unidadeId,
                    sms: unidade.sms,
                    checked: unidade.checked,
                    tipo: tipo,
                    enviaSms: unidade.enviaSms,
                }
            })
        }
    }
}
</script>